import store from "@/store";
import ContractsService from "@/services/ContractsService";
import ContractAddressesService from "@/services/ContractAddressesService";
import CountiesService from "@/services/CountiesService";
import RoutesService from "@/services/RoutesService";
import MunicipalitiesService from "@/services/MunicipalitiesService";
import HabitatsService from "@/services/HabitatsService";
import WatersService from "@/services/WatersService";
import TrapTypesService from "@/services/TrapTypesService";
import TrapNightsService from "@/services/TrapNightsService";
import TrapTeamsService from "@/services/TrapTeamsService";
import SubdivisionsService from "@/services/SubdivisionsService";
import RequestTypesService from "@/services/RequestTypesService";
import MosquitoesService from "@/services/MosquitoesService";
import ApplicatorsService from "@/services/ApplicatorsService";
import StatesService from "@/services/StatesService";
import AchemcialsService from "@/services/AchemicalsService";
import MixRatiosService from "@/services/MixRatiosService";
import WindDirectionsService from "@/services/WindDirectionsService";
import AequipService from "@/services/AequipService";
import VizualMonitorsService from "@/services/VizualMonitorsService";
import AdultAppRatesService from "@/services/AdultAppRatesService";
import AssaysService from "@/services/AssaysService";
import ResultsService from "@/services/ResultsService";
import LequipService from "@/services/LequipService";
import ControlActionsService from "@/services/ControlActionsService";
import LchemcialsService from "@/services/LchemicalsService";
import ZonesService from "@/services/ZonesService";
import SitesService from "@/services/SitesService";
import LarvaCountsService from "@/services/LarvaCountsService";
import LarvalAppRatesService from "@/services/LarvalAppRatesService";
import TrucksService from "@/services/TrucksService";

let hasLoaded = false;

const getSitesIteratively = (page = 1) => {
  return SitesService.getList(page).then((response) => {
    store.dispatch("setSitesPagesLoaded", page);
    if (page === 1) {
      const parsedUrl = new URL(response.links.last);
      const queryParams = new URLSearchParams(parsedUrl.search);
      const pageNumber = queryParams.get("page[number]");
      const lastPage = parseInt(pageNumber, 10);
      store.dispatch("setSitesTotalPages", lastPage);
    }
    store.dispatch("setSites", response.data);
    if (!!response.links.next) {
      return getSitesIteratively(page + 1);
    }
  });
};

const getServiceList = (service, mutation) => {
  return new Promise((resolve) => {
    service.getList().then((data) => {
      store.dispatch(mutation, data.data);
      resolve();
    });
  });
};

export default {
  lookups() {
    return new Promise((resolve) => {
      if (hasLoaded) {
        resolve();
        return;
      }
      hasLoaded = true;
      getSitesIteratively();
      Promise.all([
        getServiceList(ContractsService, "setContracts"),
        getServiceList(ContractAddressesService, "setContractAddresses"),
        getServiceList(CountiesService, "setCounties"),
        getServiceList(RoutesService, "setRoutes"),
        getServiceList(MunicipalitiesService, "setMunicipalities"),
        getServiceList(HabitatsService, "setHabitats"),
        getServiceList(WatersService, "setWaters"),
        getServiceList(TrapTeamsService, "setTrapTeams"),
        getServiceList(TrapNightsService, "setTrapNights"),
        getServiceList(TrapTypesService, "setTrapTypes"),
        getServiceList(SubdivisionsService, "setSubdivisions"),
        getServiceList(RequestTypesService, "setRequestType"),
        getServiceList(RequestTypesService, "setRequestType"),
        getServiceList(MosquitoesService, "setMosquitoes"),
        getServiceList(ApplicatorsService, "setApplicators"),
        getServiceList(StatesService, "setStates"),
        getServiceList(AchemcialsService, "setAchemicals"),
        getServiceList(MixRatiosService, "setMixRatio"),
        getServiceList(WindDirectionsService, "setWindDirections"),
        getServiceList(AequipService, "setAequipment"),
        getServiceList(VizualMonitorsService, "setVizualMonitors"),
        getServiceList(AdultAppRatesService, "setAdultAppRates"),
        getServiceList(AssaysService, "setAssays"),
        getServiceList(ResultsService, "setResults"),
        getServiceList(LequipService, "setLequipment"),
        getServiceList(ControlActionsService, "setControlAction"),
        getServiceList(LchemcialsService, "setLchemicals"),
        getServiceList(ZonesService, "setZones"),
        getServiceList(LarvaCountsService, "setLarvaCounts"),
        getServiceList(LarvalAppRatesService, "setLarvalAppRates"),
        getServiceList(TrucksService, "setTrucks"),
      ]).then(() => {
        store.dispatch("setAllNonSitesDataLoaded", true);
      });
      resolve();
    });
  },
};
